/* eslint-disable @typescript-eslint/naming-convention */
export const STATUS_COLOR = {
  red: '#FF0606',
  orange: '#FF8B06',
  black: '#333333',
};

export const SEND_TARGET_COLOR = {
  orange: '#F59E47',
  pink: '#E58E8E',
  green: '#4E9B29',
  lightSeaGreen: '#299B93',
};

export const NOTIFICATIONS_STATUS = {
  0: {
    name: 'STATUS.TEST_SEND',
    color: STATUS_COLOR.orange,
  },
  1: {
    name: 'STATUS.SENT',
    color: STATUS_COLOR.red,
  },
};

export const SEND_TARGET = {
  0: {
    name: 'SEND_TARGET.SYS_ADMIN',
    color: SEND_TARGET_COLOR.orange,
    roleId: 5,
  },
  1: {
    name: 'SEND_TARGET.STAFF',
    color: SEND_TARGET_COLOR.pink,
    roleId: 2,
  },
  2: {
    name: 'SEND_TARGET.RELATIVE',
    color: SEND_TARGET_COLOR.green,
    roleId: 3,
  },
  3: {
    name: 'SEND_TARGET.PARTICIPANT',
    color: SEND_TARGET_COLOR.lightSeaGreen,
    roleId: 4,
  },
};

export const NOTIFICATIONS_DETAIL_STATUS = {
  0: {
    name: 'STATUS.SEND_FAILED',
    color: STATUS_COLOR.red,
    searchKey: '失敗',
  },
  1: {
    name: 'STATUS.RECEIVE',
    color: STATUS_COLOR.black,
    searchKey: '成功',
  },
};
